module.exports = __webpack_public_path__ + "img/certificate.3a2081fe.png";